import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { useSelector, useDispatch } from 'react-redux'
import { Redirect } from 'react-router-dom';
import { Alert, Button, TabContent, TabPane, Nav, NavItem, NavLink, Table, Row, Col } from 'reactstrap';
import { VictoryPie, VictoryBar, VictoryLine, VictoryScatter, VictoryChart, VictoryAxis, VictoryLabel, /* VictoryContainer, VictoryZoomContainer, */ VictoryTheme } from 'victory';
import classnames from 'classnames';
import SelectRecord from './SelectRecord';
import Selections from './Selections';
import * as Records from '../store/Records';
import * as Accounts from '../store/Accounts';
import NotAuthenticated from './NotAuthenticated';
import DropdownSelection from '../data/DropDown';
import './Common.css';


const fixedDataSiteContacts = [
	{ siteCode: "09", siv: "", activation: "", siteName: "Grandview Medical Center", siteLocation: "3690 Grandview Parkway Birmingham, Alabama 35243", siteCountry: "USA", sitePI: "Dr. Anil Rajendra arajendra@alcardio.com", siteMainContact: "Laura Sparks/  laura.sparks@grandviewhealth.com", siteBackupContact: "Lisa Creel  lcreel@alcardio.com", phone: "205-971-7553", siteTraining: "Training completed on 11/21/2018" },
	{ siteCode: "11", siv: "", activation: "", siteName: "Texas Cardiac Arrhythmia Research Foundation", siteLocation: "3000 N Interstate 35, Suite 705 Austin, Texas 78705", siteCountry: "USA", sitePI: "Dr. Amin AL-Ahmad      tcarfaa@gmail.com", siteMainContact: "Cheri Maestas cases@austinheartbeat.com", siteBackupContact: "", phone: "512-807-3150 ", siteTraining: "Training completed on 12/11/2019 By the sponsor " },
	{ siteCode: "14", siv: "", activation: "", siteName: "MGH", siteLocation: "55 Fruit St. Boston, MA 02114", siteCountry: "USA", sitePI: "Dr. Moussa Mansour mmansour@mgh.harvard.edu", siteMainContact: "Kevin Marzotto/ kmarzotto@mgh.harvard.edu       Matthew Silas MSILAS@mgh.harvard.edu                    Grace Ha                                                GHA2@mgh.harvard.edu       Matthew Cobler                                                    MCOBLER-LICHTER@mgh.harvard.edu  Andrea Aase andrea.d.aase@medtronic.com", siteBackupContact: "", phone: "617-726-0280", siteTraining: "Training completed on 10/24/2018" },
	{ siteCode: "15", siv: "", activation: "", siteName: "Jackson Heart", siteLocation: "970 lakeland Dr. Suite 61 Jackson, MS 39216", siteCountry: "USA", sitePI: "Dr. Judson Colley researchdocs@jacksonheart.com", siteMainContact: "Claire Hammack   chammack@jacksonheart.com", siteBackupContact: "Sandy Puckett swpuckett@jacksonheart.com", phone: "601-982-7850 EXT 267", siteTraining: "Training completed on 11/01/2018" },
	{ siteCode: "13", siv: "", activation: "", siteName: "UAB", siteLocation: "510 20th St. South Birmingham, AL 35233", siteCountry: "USA", sitePI: "Dr. William Maddox  wmaddox@uabmc.edu", siteMainContact: "Jane Vines/ jsnowden@uabmc.edu", siteBackupContact: "Thomas Frazier thomasfrazier@uabmc.edu", phone: "205-975-4335", siteTraining: "Training completed on 11/16/2018" },
	{ siteCode: "12", siv: "", activation: "", siteName: "MUSC", siteLocation: "25 Courtenay Drive Charleston, SC  29425  ", siteCountry: "USA", sitePI: "Micheal Field                   fieldme@musc.edu", siteMainContact: "Chandler Schwede, schwede@musc.edu                                       Deborah Everidge/ adamsde@musc.edu", siteBackupContact: "", phone: "843-792-0464", siteTraining: "Training completed on  12/07/2018" },
	{ siteCode: "10", siv: "", activation: "", siteName: "USC", siteLocation: "1510 San Pablo St. Suite 322 Los Angeles, CA 90033", siteCountry: "USA", sitePI: "Rahual Doshi   Rahul.Doshi@med.usc.edu", siteMainContact: "Melissa Ramos/ melissa.ramos@med.usc.edu", siteBackupContact: "Silvia Perez Silvia.Perez@med.usc.edu", phone: "323-442-6130", siteTraining: "Training completed on 1/22/2019" },
	{ siteCode: "17", siv: "", activation: "", siteName: "Ochsner Medical Center", siteLocation: "1514 Jefferson Highway New Orleans, LA  70121", siteCountry: "USA", sitePI: "", siteMainContact: "Melanie Lunn  mlunn@ochsner.org", siteBackupContact: "Stacey Davis sdavis@ochsner.org", phone: "504-842-2372", siteTraining: "Training Pending " },
	{ siteCode: "18", siv: "", activation: "", siteName: "Mount Sinai ", siteLocation: "One Gustave L. Levy Plaza New York, NY  70121", siteCountry: "USA", sitePI: "Srinivas Dukkipati MD ", siteMainContact: "Esther Pena                  esther.pena@mountsinai.org", siteBackupContact: "Sam Cammack                  sam.cammack@mountsinai.org", phone: "212-824-8928", siteTraining: "Training completed on 12/18/2018 " },
	{ siteCode: "19", siv: "", activation: "", siteName: "Montefiore Medical Center", siteLocation: "3319 Rochambeau Avenue Bronx, NY 10467", siteCountry: "USA", sitePI: "Luigi Di Biase      ldibiase@montefiore.org", siteMainContact: "Dalvert Polanco/ dapolanc@montefiore.org", siteBackupContact: "", phone: "718-920-6442", siteTraining: "Training completed on 01/25/2019" },
	{ siteCode: "20", siv: "", activation: "", siteName: "Southlake Regional Hospital", siteLocation: "Medical Arts Building 2nd Floor Suite 206 596 Davis Drive Newmarket, ON L3Y2P9", siteCountry: "USA", sitePI: "", siteMainContact: "Sherri Patterson spatterson@southlakeregional", siteBackupContact: "Annette Nath/ anath@southlakeregional.org", phone: "905-895-4521 EXT 2945   ", siteTraining: "Training Pending " },
	{ siteCode: "22", siv: "", activation: "", siteName: "Houston Methodist", siteLocation: "6550 Fannin St, Suite 1901 Houston, TX  77030", siteCountry: "USA", sitePI: "Miguel Valderrabano mvalderrabano@houstonmethodist.org", siteMainContact: "Maria Del Pino        mdelpino@houstonmethodist.org", siteBackupContact: "Patricia Brinegar      PBrinegar@houstonmethodist.org", phone: "713-441-3912", siteTraining: "Training completed on 5/14/2019" },
	{ siteCode: "23", siv: "", activation: "", siteName: "Trident Medical Center", siteLocation: "9304 Medical Plaza Drive  Charleston, SC  29406", siteCountry: "USA", sitePI: "Darren Sidney Darren.Sidney@HCAhealthcare.com", siteMainContact: " Sally Mathews, sally.mathews@hcahealthcare.com     Tina Cooper   Tina.Cooper@hcahealthcare.com", siteBackupContact: "  ", phone: "843-729-0091", siteTraining: "Training Completed on 12/17/2018" },
	{ siteCode: "24", siv: "", activation: "", siteName: "Florida Hospital ", siteLocation: "483 N. Sermoran Blvd, Suite 102 Winter Park, FL  32792", siteCountry: "USA", sitePI: "Usman Siddiqui          siddiqui.u@gmail.com", siteMainContact: "Leann Goodwin Leann.Goodwin@AdventHealth.com", siteBackupContact: "Deanna Allen               Deanna.allen2@flhosp.org        Kimberly Cawthorn  kimberly.cawthon@flhosp.org", phone: "407-645-1847", siteTraining: "Training completed on 2/01/2019" },
	{ siteCode: "28", siv: "", activation: "", siteName: "NMHS", siteLocation: "830 South Gloster St.   Third Floor East Tower Tupelo, MS 38801", siteCountry: "USA", sitePI: "", siteMainContact: "Amber Schmitz            Anschmitz@nmah.net ", siteBackupContact: "", phone: "662-377-7572", siteTraining: "Training completed on 2/27/2019" },
	{ siteCode: "16", siv: "", activation: "", siteName: "Montreal", siteLocation: "", siteCountry: "canada", sitePI: "", siteMainContact: "Mary Morello                  Mary.morello@icm-mhi.org", siteBackupContact: "", phone: "", siteTraining: "Training pending " },
	{ siteCode: "27", siv: "", activation: "", siteName: "Sequoia Hospital ", siteLocation: "170 Alameda de las Pulgas, Redwood City, CA 94062", siteCountry: "USA", sitePI: "Gregory Engel                 EngelG@pamf.org", siteMainContact: "Zayna Shaheen zayna.shaheen@dignity", siteBackupContact: "Juanita.Fujii Juanita.Fujii@Dignityhealth.org", phone: "650-482-6072                  Mobile 650-678-9000", siteTraining: "Training completed on 6/21/2019" },
	{ siteCode: "29", siv: "", activation: "", siteName: "Kansa City Heart Rhythm Institute ", siteLocation: "12200 W. 106th Street, Suite 320, Overland Park, KS 66215", siteCountry: "USA", sitePI: "Dhanunjaya Lakkireddy         dhanunjaya.lakkireddy@hcahealthcare.com", siteMainContact: "Srivani Sakamuri  srivani.sakamuri@hcahealthcare.com", siteBackupContact: "Donita Atkins  Donita.Atkins@HCAhealthcare.com", phone: "816-651-1969", siteTraining: "Training completed 3/15/2019" },
];

const fixedDataSponsors = [
	{ sponsorName: "Epix", contactName: "Jessica Lukken", title: "", email: "jessica.x.lukken@medtronic.com", phone: "", address: "" },
	{ sponsorName: "EPIX ", contactName: "Debbie Theisen", title: "", email: "debbie.r.theisen@medtronic.com", phone: "", address: "" },
	{ sponsorName: "Advanced Cardiac Therapeutics", contactName: "Lauren Intagliata", title: "DATA BASE ONLY", email: "lintagliata@araonline.net", phone: "DATA BASE ONLY", address: "" },
	{ sponsorName: "Advanced Cardiac Therapeutics", contactName: "Scott Stange", title: "DATA BASE ONLY", email: "stange@araonline.net", phone: "DATA BASE ONLY", address: "" },
];



export default function Dashboard(props)
{
	const [studyId] = useState( props.location.state && props.location.state.studyId ); 
	const [studyName] = useState( props.location.state && props.location.state.studyName ); 
	var [isHcsRole,setIsHcsRole] = useState(false);

	if ( ! studyId ) {
		return <Redirect to={{ pathname: "/" }} />;
	}

	// redux usage
	const dispatch = useDispatch();
	const accountsState = useSelector(state => state.accounts);
	const recordsState = useSelector(state => state.records);
	const recordsDispatch = bindActionCreators(Records.actionCreators, dispatch);


	if ( ! accountsState.authenticated && ! accountsState.fetching ) {
		if ( accountsState.authenticatedAccount ) {
			isHcsRole = Accounts.isHcsRole(accountsState.authenticatedAccount.role)
		}
	}



	/* fetch a refresh of the allCompliancyRows data when the study changes */
	const refreshAllCompliancyRows = (! recordsState.allCompliancyRows || (recordsState.allCompliancyRows && recordsState.allCompliancyRows["studyId"] && (recordsState.allCompliancyRows["studyId"] !== studyId)));

	/* fetch the compliancy summary data */
	if ( isHcsRole && ! recordsState.fetching && refreshAllCompliancyRows ) {
		recordsState.allCompliancyRows = null;
		recordsDispatch.getAllCompliancyRows(studyId);
	}


	/* occurs after each render */
	useEffect(() => {
		if ( accountsState.authenticatedAccount ) {
			setIsHcsRole( Accounts.isHcsRole(accountsState.authenticatedAccount.role) );
		}

		/* download data if it's been loaded */
		if ( recordsState.dataXls && recordsState.dataXls.data ) {
			const contentType = 'application/vnd.ms-excel';
			const fileName = "Compliancy " + recordsState.allStudyName + ".xls";
			const linkSource = `data:${contentType};base64,${recordsState.dataXls.data}`;
			const downloadLink = document.createElement("a");
			downloadLink.href = linkSource;
			downloadLink.download = fileName;
			downloadLink.click();
			recordsState.dataXls = { data: null, studyId: null };
			document.getElementById("btnDownloadCompliancySpreadsheet").style.visibility = "visible";
		}

		return () => {
			cleanupBeforeReRender();
		};
	});


	/* render now */
	return (
		<div className="gap-bottom">
			<h3> Study Dashboard </h3>
			<h2> Study: <span className="bold"> {studyName} </span> </h2>
	
			<div className="gap">
				<TabControl studyId={studyId} studyName={studyName} isHcsRole={isHcsRole} recordsState={recordsState} recordsDispatch={recordsDispatch} />
			</div>
		</div>
	);
}


function cleanupBeforeReRender()
{
}



function TabControl(props)
{
	const [activeTab, setActiveTab] = useState('SelectRecord');
	const [patientCode, setPatientCode] = useState(null);
	let isHcsRole = props.isHcsRole;
	let isAuthenticated = true;

	const toggle = (tab, patientCode) => {
		if ( activeTab !== tab ) {
			setActiveTab(tab);
		}

		if ( patientCode ) {
			setPatientCode(patientCode);
			props.recordsState.patientFilter = patientCode;
		}
	}

	const accountsState = useSelector(state => state.accounts);
	if ( ! Accounts.authenticatedAllRoles(accountsState) ) {
		isAuthenticated = false;
		isHcsRole = false;
	}

	return <div>
			<Nav tabs>
				<TabSelectRecords isHeader={true} activeTab={activeTab} toggle={toggle} />
				<TabSummaryCharts isHeader={true} activeTab={activeTab} toggle={toggle} />
				<TabCompliance isHeader={true} activeTab={activeTab} toggle={toggle} />
				<TabSelections isHeader={true} activeTab={activeTab} toggle={toggle} />
				<TabSiteContacts isHeader={true} activeTab={activeTab} toggle={toggle} />
				<TabSponsorContacts isHeader={true} activeTab={activeTab} toggle={toggle} />
			</Nav>

			<TabContent activeTab={activeTab}>
				{ isAuthenticated && <TabSelectRecords isHeader={false} activeTab={activeTab} studyId={props.studyId} studyName={props.studyName} patientFilter={patientCode} /> }
				{ isHcsRole && <TabSummaryCharts isHeader={false} /> }
				{ isHcsRole && <TabCompliance isHeader={false} studyId={props.studyId} recordsState={props.recordsState} recordsDispatch={props.recordsDispatch} /> }
				{ isHcsRole && <TabSelections isHeader={false} studyId={props.studyId} studyName={props.studyName} selectTab={(patientCode) => toggle('SelectRecord',patientCode)} /> }
				{ isHcsRole && <TabSiteContacts isHeader={false} /> }
				{ isHcsRole && <TabSponsorContacts isHeader={false} /> }
				{ ! isHcsRole && <NotAuthenticated /> }
			</TabContent>

	</div>;
}


function TabSelections(props)
{
	if ( props.isHeader ) {

		return <NavItem>
			<NavLink
				className={classnames({ active: props.activeTab === 'Selections' })}
				onClick={() => { props.toggle('Selections'); }}
			>
				Sites...
			</NavLink>
		</NavItem> ;

	} else {

		return <TabPane tabId='Selections'>
			<Selections studyId={props.studyId} studyName={props.studyName} isVisible={(props.activeTab === 'Selections')} selectTab={props.selectTab} />
		</TabPane> ;
	}
}

function TabSelectRecords(props)
{
	if ( props.isHeader ) {

		return <NavItem>
			<NavLink
				className={classnames({ active: props.activeTab === 'SelectRecord' })}
				onClick={() => { props.toggle('SelectRecord'); }}
			>
				Records
			</NavLink>
		</NavItem> ;

	} else {

		return <TabPane tabId='SelectRecord'>
			<SelectRecord state={{ studyId: props.studyId, studyName: props.studyName, isVisible: (props.activeTab === 'SelectRecord'), patientCode: props.patientCode }}/>
		</TabPane> ;
	}
}


function TabSummaryCharts(props)
{
	const [currentServiceType, setCurrentServiceType] = useState( Records.recordServiceTypes.event ); 

	if ( props.isHeader ) {

		return <NavItem>
			<NavLink
				className={classnames({ active: props.activeTab === 'Summary' })}
				onClick={() => { props.toggle('Summary'); }}
			>
				Summary
			</NavLink>
		</NavItem> ;

	} else {
		const recordsState = useSelector(state => state.records);

		if ( recordsState.allCompliancyRows ) {
			const data = {
				[Records.recordServiceTypes.event]: getRowData(recordsState.allCompliancyRows["eventRows"]),
				[Records.recordServiceTypes.holter]: getRowData(recordsState.allCompliancyRows["holterRows"]),
				[Records.recordServiceTypes.twelveLead]: getRowData(recordsState.allCompliancyRows["twelveLeadRows"]),
			};

			const classNameInput = "scheduler";
			let arrServiceTypes = [ Records.recordServiceTypes.event, Records.recordServiceTypes.holter, Records.recordServiceTypes.twelveLead ];

			return <TabPane tabId='Summary'>
				<h3> {currentServiceType} Compliancy </h3>

				<DropdownSelection
						disabled={false}
						id="dropdown_ServiceType"
						isCheckboxes={false}
						className={classNameInput}
						values={[currentServiceType]}
						selections={arrServiceTypes}
						onSelect={(arr) => setCurrentServiceType(arr[0])} />

				<Row>
					<BarChartCompliancy currentServiceType={currentServiceType} data={data} />
				</Row>

				<Row>
					&nbsp;
				</Row>

				<Row>
					<h3> Enrollments </h3>
					{<ChartPie data={data} />}
				</Row>

			</TabPane> ;

		} else {

			return <TabPane tabId='Summary'>
				<h3> Compliancy </h3>

				<Alert color="primary"> Loading... </Alert>

			</TabPane> ;
			}
	}
}


function TabSiteContacts(props)
{
	if ( props.isHeader ) {

		return <NavItem>
			<NavLink
				className={classnames({ active: props.activeTab === 'SiteContacts' })}
				onClick={() => { props.toggle('SiteContacts'); }}
			>
				Site Contacts
			</NavLink>
		</NavItem> ;

	} else {

		return <TabPane tabId='SiteContacts'>
			<h3> Site Contacts </h3>

			<Table striped>
			<tbody className="tbody-block ComplianceTableHeader" >
				<tr>
					<th> Site </th>
					<th> SIV </th>
					<th> Site Name </th>
					<th> Activation </th>
					<th> Site Location </th>
					<th> Country </th>
					<th> Pi </th>
					<th> Site Main Contact </th>
					<th> Site Contact (Back-up) </th>
					<th> Phone </th>
					<th> Site Training </th>
				</tr>

			{
				fixedDataSiteContacts.map( (record,idx) => {
					return (
						<tr key={idx}>
							<td> {record.siteCode} </td>
							<td> {record.siv} </td>
							<td> {record.activation} </td>
							<td> {record.siteName} </td>
							<td> {record.siteLocation} </td>
							<td> {record.siteCountry} </td>
							<td> {record.sitePI} </td>
							<td> {record.siteMainContact} </td>
							<td> {record.siteBackupContact} </td>
							<td> {record.phone} </td>
							<td> {record.siteTraining} </td>
						</tr>
					);
				})
			}
			</tbody>

			</Table>
		</TabPane> ;
	}
}


function TabSponsorContacts(props)
{
	if ( props.isHeader ) {

		return <NavItem>
				<NavLink
					className={classnames({ active: props.activeTab === 'SponsorContacts' })}
					onClick={() => { props.toggle('SponsorContacts'); }}
				>
					Sponsor Contacts
				</NavLink>
			</NavItem>

	} else {

		return <TabPane tabId='SponsorContacts'>
			<h3> Sponsor Contacts </h3>

			<Table striped>
			<tbody className="tbody-block ComplianceTableHeader" >
			<tr>
				<th> Sponsor Name </th>
				<th> Contact Name </th>
				<th> Title </th>
				<th> Email </th>
				<th> Phone Number </th>
				<th> Address </th>
			</tr>

			{
				fixedDataSponsors.map( (record,idx) => {
					return (
						<tr key={idx}>
							<td lg="3"> {record.sponsorName} </td>
							<td lg="3"> {record.contactName} </td>
							<td lg="1"> {record.title} </td>
							<td lg="3"> {record.email} </td>
							<td lg="1"> {record.phone} </td>
							<td lg="1"> {record.address} </td>
						</tr>
					);
				})
			}
			</tbody>

			</Table>
		</TabPane> ;
	}
}


function ChartPie(props)
{
	const [data] = useState( props.data ); 
	let compliancyRows = null;
	
	if ( data[Records.recordServiceTypes.event] && data[Records.recordServiceTypes.event].length > 0 ) {
		compliancyRows = data[Records.recordServiceTypes.event];
	} else
	if ( data[Records.recordServiceTypes.holter] && data[Records.recordServiceTypes.holter].length > 0 ) {
		compliancyRows = data[Records.recordServiceTypes.holter];
	} else
	if ( data[Records.recordServiceTypes.twelveLead] && data[Records.recordServiceTypes.twelveLead].length > 0 ) {
		compliancyRows = data[Records.recordServiceTypes.twelveLead];
	}

	if ( compliancyRows === null ) {
		return <Alert color="danger"> No Data </Alert>;
	}

	const totalPatients = compliancyRows.reduce((acc, cr) => acc + cr.cntPatients, 0);
	const dataMassaged = compliancyRows.map( r => { return ({ x: r.siteName, y: Math.round(100 * r.cntPatients / Math.max(1,totalPatients)) }); } );

	return <Col className="col-8 centerOnly"
		   >
			<VictoryPie
				data={dataMassaged}
				style={{
					labels: {
						fontSize: 5,
						fill: "black"
					}
				}}
				theme={VictoryTheme.material}
				// colorScale="warm"
				// colorScale="heatmap"
				colorScale="qualitative"
				// colorScale="cool"
				// colorScale="blue"
				labels={({datum}) => { return `${datum.x} (${datum.y}%)`; } }
				labelComponent={<VictoryLabel angle={10}/>}
				padding={{left: 100, right: 100 }}
			>
			</VictoryPie>
		</Col>
	;
}


function BarChartCompliancy(props)
{
	const currentServiceType = props.currentServiceType; 
	const data = props.data[currentServiceType];

	const lineGraphOffset = 0;
	// const lineGraphMultiplier = 8;
	const lineGraphMultiplier = 2;

	if ( data.length === 0 ) {
		return <Alert color="danger"> No Data </Alert>;
	}

	let dataMassaged = data.flatMap( (rec,idx) => {
			return (
				[
					{ x: 1 + idx * 4 + 0, y: rec.cntPatients },
					{ x: 1 + idx * 4 + 1, y: rec.cntMade },
					{ x: 1 + idx * 4 + 2, y: rec.cntTotal },
				]
			);
		});

	dataMassaged.push( { x: 1 + dataMassaged.length + 1, y: 0 } );

	const dataCompliancy = data.flatMap( (rec,idx) => {
			return (
				[
					{ x: 1 + idx * 4 + 1, y: lineGraphOffset + lineGraphMultiplier * Math.round(100 * rec.cntMade / Math.max(1,rec.cntTotal)) },
				]
			);
		});

	const myTickLabels = data.flatMap( (rec,idx) => {
			return (
				[
					"",
					rec.siteName,
					"",
					"",
				]
			);
		});

	return <VictoryChart
				// adding the material theme provided with Victory
				theme={VictoryTheme.material}
				colorScale="cool"
				// containerComponent={ <VictoryZoomContainer/> }
				height={400}
				width={1000}
				padding={{ top: 0, bottom: 200, left: 50, right: 10 }}
				domainPadding={{x: 0, y: 25}}
			>

				<VictoryAxis
					tickValues={Array.from(Array(myTickLabels.length).keys(), n => n )}
					tickFormat={myTickLabels}
					tickLabelComponent={<VictoryLabel textAnchor="start" verticalAnchor="middle" angle={30} />}
				/>
				<VictoryAxis
					dependentAxis
					tickFormat={(x) => (`${x}`)}
				/>

				<VictoryBar
					data={dataMassaged}
					labels={({ datum }) => `${datum.y}` }
				/>

				<VictoryLine
					data={dataCompliancy}
					labels={({ datum }) => `${(datum.y > 0) ? (((datum.y - lineGraphOffset) / lineGraphMultiplier)+'%') : ''}` }
				/>
				<VictoryScatter data={dataCompliancy}
					size={4}
					style={{ data: { fill: "#c43a31" } }}
          		/>

			</VictoryChart>
	;
}

function TabCompliance(props)
{
	if ( props.isHeader ) {

		return <NavItem>
			<NavLink
				className={classnames({ active: props.activeTab === 'Compliance' })}
				onClick={() => { props.toggle('Compliance'); }}
			>
				Compliance
			</NavLink>
		</NavItem> ;

	} else {

		const handleDownloadRequest = () => {
			document.getElementById("btnDownloadCompliancySpreadsheet").style.visibility = "hidden";
			props.recordsDispatch.getSpreadsheetCompliancy(props.studyId);
		};

		return <TabPane tabId='Compliance'>
			<h2> Compliance </h2>
			<Button className="button" id="btnDownloadCompliancySpreadsheet" title="Download" onClick={handleDownloadRequest}> Download Compliancy Spreadsheet </Button>
			<div className="complianceColumns">
				<TabComplianceTable isHeader={false} title='Event Compliance' tabName='ComplianceEvent' compRowsName='eventRows' />
				<TabComplianceTable isHeader={false} title='Holter Compliance' tabName='ComplianceHolter' compRowsName='holterRows' />
				<TabComplianceTable isHeader={false} title='12-Lead Compliance' tabName='Compliance12Lead' compRowsName='twelveLeadRows' />
			</div>
		</TabPane> ;
	}
}


function TabComplianceTable(props)
{
	if ( props.isHeader ) {

		return <NavItem>
			<NavLink
				className={classnames({ active: props.activeTab === props.tabName })}
				onClick={() => { props.toggle(props.tabName); }}
			>
				{props.title}
			</NavLink>
		</NavItem> ;

	} else {
		const recordsState = useSelector(state => state.records);

		if ( recordsState.allCompliancyRows ) {
			const rowData = getRowData(recordsState.allCompliancyRows[props.compRowsName]);

			return <TabPane tabId={props.tabName}>
				<h3> {props.title} </h3>

				<Table striped>
				<tbody className="tbody-block ComplianceTableHeader" >
				<tr>
					<th lg="4"> Site Name </th>
					<th lg="1"> Patients </th>
					<th lg="1"> Made </th>
					<th lg="1"> Total </th>
					<th lg="1"> Compliance </th>
				</tr>

				{
					( rowData.length === 0 ) ?
						<tr>
							<td colSpan="5">
								<Alert color="danger"> No Data </Alert>
							</td>
						</tr>
					:
						rowData.map( (r,idx) => {
							return (
								<tr key={idx}>
									<td lg="4" className="leftAligned"> {r.siteName} </td>
									<td lg="1" className="center"> {r.cntPatients} </td>
									<td lg="1" className="center"> {r.cntMade} </td>
									<td lg="1" className="center"> {r.cntTotal} </td>
									<td lg="1" className="center"> { Math.round(100 * r.cntMade / Math.max(1,r.cntTotal)) }% </td>
								</tr>
							);
						})
				}
				</tbody>

				</Table>

			</TabPane> ;

		} else {

			return <TabPane tabId={props.tabName}>
				<h3> {props.title} </h3>
				<Table striped>
				<tbody className="tbody-block ComplianceTableHeader" >
				<tr>
					<th lg="4"> Site Name </th>
					<th lg="1"> Patients </th>
					<th lg="1"> Made </th>
					<th lg="1"> Total </th>
					<th lg="1"> Compliance </th>
				</tr>

				<tr>
					<td colSpan="5">
						<Alert color="primary"> Loading... </Alert>
					</td>
				</tr>

				</tbody>

				</Table>

			</TabPane> ;
		}
	}
}

function getRowData( compliancyRows )
{
	let rowData = [];

	if ( ! compliancyRows || compliancyRows.length === 0 ) {
		return rowData;
	}

	/* find all the site names */
	let siteNames = [...new Set(compliancyRows.map(row => row.siteName))];

	/* create an object for each site */
	for ( var idxSite = 0 ; idxSite < siteNames.length ; idxSite++ ) {
		rowData.push( { siteName: siteNames[idxSite], cntPatients: 0, cntMade: 0, cntExtra: 0, cntTotal: 0 } );
	}

	for ( var i = 0 ; i < compliancyRows.length ; i++ ) {

		const sName = compliancyRows[i].siteName;
		const idx = siteNames.findIndex( x => x === sName );

		const total = Math.max( isNaN(compliancyRows[i].total) ? 0 : compliancyRows[i].total, 0 );
		const made = Math.max( isNaN(compliancyRows[i].made) ? 0 : compliancyRows[i].made, 0 );
		const extra = Math.max( isNaN(compliancyRows[i].extra) ? 0 : compliancyRows[i].extra, 0 );

		rowData[idx]["siteName"] = sName;
		rowData[idx]["cntPatients"] = (isNaN(rowData[idx]["cntPatients"]) ? 0 : rowData[idx]["cntPatients"]) + 1;
		rowData[idx]["cntMade"] = (isNaN(rowData[idx]["cntMade"]) ? 0 : rowData[idx]["cntMade"]) + made;
		rowData[idx]["cntTotal"] = (isNaN(rowData[idx]["cntTotal"]) ? 0 : rowData[idx]["cntTotal"]) + total;
		rowData[idx]["cntExtra"] = (isNaN(rowData[idx]["cntExtra"]) ? 0 : rowData[idx]["cntExtra"]) + extra;
	}

	return rowData;
}




// WEBPACK FOOTER //
// ./src/components/Dashboard.js